import { store } from "../";
import { IAutoplaySetting } from "../containers/AutoplaySettings/Common/AutoplaySettings";
import { showError } from "../utils/errorHandler";
import {
  arrayContainsDuplicates,
  arrayContainsOnlyIntegers,
  arrayContainsOnlyPositiveNumbers
} from "./utils";

export const roundsValues = (values: number[], origin?: string): boolean => {
  if (!Array.isArray(values)) {
    showError("Autoplay rounds values has to be an array", origin);
    return false;
  } else if (values.length < 1) {
    showError("Autoplay rounds values must contain at least 1 choice", origin);
    return false;
  } else if (!arrayContainsOnlyIntegers(values)) {
    showError("Autoplay rounds values array can only contain integers", origin);
    return false;
  } else if (!arrayContainsOnlyPositiveNumbers(values)) {
    showError(
      "Autoplay rounds values array can only contain positive integers",
      origin
    );
    return false;
  } else if (arrayContainsDuplicates<number>(values)) {
    showError(
      "Autoplay rounds values array cannot contain duplicate values",
      origin
    );
    return false;
  }

  return true;
};

export const rounds = (value: number, origin?: string): boolean => {
  const availableRounds = store.getState().autoplay.settings.rounds;

  if (!Number.isInteger(value)) {
    showError("Rounds has to be an integer", origin);
    return false;
  } else if (!availableRounds.includes(value)) {
    showError("Rounds has to be valid autoplay rounds", origin);
    return false;
  }

  return true;
};

export const roundsLeft = (value: number, origin?: string): boolean => {
  if (!Number.isInteger(value)) {
    showError("Rounds left has to be an integer", origin);
    return false;
  } else if (value < 0) {
    showError("Rounds left has to be a positive number", origin);
    return false;
  }

  return true;
};

export const autoplaySettings = (
  values: IAutoplaySetting[],
  origin?: string
): boolean => {
  if (!Array.isArray(values)) {
    showError("Autoplay settings has to be an array", origin);
    return false;
  }
  return true;
};

export const autoplaySetting = (
  value: IAutoplaySetting,
  origin?: string
): boolean => {
  const settings = store.getState().autoplay.settings.settings;

  if (typeof value !== "object") {
    showError("Autoplay setting has to be an object", origin);
    return false;
  }

  if (settings.findIndex(element => element.id === value.id) === -1) {
    showError("Autoplay setting to be updated has to be in the store", origin);
    return false;
  }

  return true;
};
